<div
  class="sz-partner-card"
  [class.sz-partner-card--inline]="isInline()"
  [class.sz-partner-card--logo-full]="logoFull()"
  [class.sz-partner-card--clickable]="clickable()"
  [style.--partner-accent]="accent()"
  [attr.role]="clickable() ? 'button' : null"
  [attr.tabindex]="clickable() ? 0 : null"
  [attr.aria-label]="clickable() ? ctaAria() || logoAlt() || null : null"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()">
  @if (dismissible()) {
    <button
      type="button"
      class="sz-partner-card__dismiss"
      [attr.aria-label]="dismissAria() || null"
      (click)="dismissed.emit()">
      <sz-icon name="x" [size]="16" />
    </button>
  }

  <div class="sz-partner-card__head">
    <img class="sz-partner-card__logo" [src]="logoSrc()" [alt]="logoAlt()" />
    @if (label()) {
      <span class="sz-partner-card__label">{{ label() }}</span>
    }
  </div>

  @if (headline() || description()) {
    <div class="sz-partner-card__body">
      @if (headline()) {
        <p class="sz-partner-card__headline">{{ headline() }}</p>
      }
      @if (!isInline() && description()) {
        <p class="sz-partner-card__desc">{{ description() }}</p>
      }
    </div>
  }

  @if (ctaLabel()) {
    @if (isInline() || linkCta()) {
      <button type="button" class="sz-partner-card__link" [attr.aria-label]="ctaAria() || null" (click)="onCtaClick()">
        {{ ctaLabel() }}
      </button>
    } @else {
      <div class="sz-partner-card__cta">
        <sz-button variant="secondary" [fullWidth]="true" (click)="onCtaClick()">
          {{ ctaLabel() }}
        </sz-button>
      </div>
    }
  }
</div>
